<div class="point-summary-root" *transloco="let t">
  <div class="point-summary-line">
    <div class="total-points-card">
      <div class="total-points-left-panel">
        <div class="total-points-icon-panel">
          <mat-icon class="icon total-label"
            [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
            stars
          </mat-icon>
        </div>
      </div>
      <div class="total-points-right-panel">
        <div class="description-label total-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.totalPoints}}
        </div>
        <div class="value-label total-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.totalPoints | number:'': language }}
        </div>
      </div>
    </div>
    <div class="horizontal-space"></div>
    <div class="small-card line-card">
      <div class="single-card flex-33">
        <div class="description-label variable-label" 
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }" >
          {{labels.pointsAddedMonth}} 
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.addedOnThisMonth | number:'': language }}
        </div>
         
      </div>
      <div class="single-card flex-33">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.pointsRedeemedMonth}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.redeemedOnThisMonth | number:'': language }}
        </div>
      </div>
      <div class="single-card flex-33">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.pointsExpired}}{{getThisYear()-1}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.expiredLastYear | number:'': language }}
        </div>
      </div>
    </div>
  </div>

  <div class="point-summary-line spacing-top-10">
    <div class="medium-card line-card">
      <div class="single-card flex-25">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.pointsExpiringMonth}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.expiringOnThisMonth | number:'': language }}
        </div>
      </div>
      <div class="single-card flex-25">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.nextPointsExpiring}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{nextPointsExpiring | number:'': language }} ({{ nextPointsExpiringDate | date : 'MMM-dd-yyyy' : 'UTC' : language }})
        </div>
      </div>
      <div class="single-card flex-25">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.pointsExpiring}}{{getThisYear()}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.expiringOnThisYear | number:'': language }}
        </div>
      </div>
      <div class="single-card flex-25">
        <div class="description-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{labels.pointsExpiring}}{{getThisYear()+1}}
        </div>
        <div class="value-label variable-label"
          [ngClass]="{ 'variable-label-disabled': timelineDisabled }">
          {{ pointSummary?.expiringOnNextYear | number:'': language }}
        </div>
      </div>
    </div>
  </div>
</div>
